// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__uHwgs","inputWrap":"CustomTip_inputWrap__1U1WQ"};